import React from 'react';
import ConfirmationDialog from '../../ConfirmationDialog';

const Body = ({ selectedTasks }) => {
    return (
        <div className="sign-dialog">
            {selectedTasks.map(task =>
                <div  key={task.taskId} className="sign-dialog--task">
                    <div>TASK:</div>
                    <div>{task.description}</div>
                </div>
            )}
        </div>
    );
}

const TaskTemporaryDialog = ({ tasks, role, onClose, onAccept, ...props }) =>
    <ConfirmationDialog
        {...props}
        onClose = { onClose }
        cancelButton={{
            action: onClose,
            label: 'NO, CANCEL'
        }}
        acceptButton={{
            action: onAccept,
            label: 'YES, MARK TEMPORARY'
        }}
        header="Are you sure you want to mark the following tasks as temporary?"
        body={<Body selectedTasks={tasks} />}
    />;

export default TaskTemporaryDialog;